import { createContext, useContext } from 'react';

// A mesma implementação de dashboard, com escopo fixado pela página.
// Não é permissão: as regras de acesso existentes continuam sendo aplicadas.
export type SegmentoVisao = 'PF' | 'PJ';
export const SegmentoVisaoContext = createContext<SegmentoVisao>('PJ');
export const useSegmentoVisao = () => useContext(SegmentoVisaoContext);
